import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
import {
  SearchMemberAssurancesParams,
  MemberAssuranceRequest,
} from "@/interfaces/assurance";

import { members_assurances, clubUUID, paginationLinks } from "@/shared/state";

import router from "@/router/index";
const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useMemberAssurance() {
  const isRequestMemberAssurance = ref<boolean | false>(false);
  const errorMemberAssurance = ref<boolean | false>(false);
  const Toast = Swal.mixin({
    toast: true,
    position: "top-right",
    showConfirmButton: false,
    timer: 12000,
    timerProgressBar: true,
  });

  const fetchMembersAssurances = async (body: SearchMemberAssurancesParams) => {
    try {
      isRequestMemberAssurance.value = true;
      errorMemberAssurance.value = false;
      members_assurances.data = [];
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}members/assurances/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        if (body?.type === "paginate") {
          members_assurances.data = response?.data?.data || [];
          paginationLinks.value = response?.data;
          delete paginationLinks.value.data;
        } else if (body?.type === "all") {
          members_assurances.data = response?.data || [];
        }
        isRequestMemberAssurance.value = false;
      }
    } catch (err) {
      errorMemberAssurance.value = true;
      isRequestMemberAssurance.value = false;
    }
  };

  const regulationMemberAssurance = async (body: MemberAssuranceRequest) => {
    try {
      isRequestMemberAssurance.value = true;
      errorMemberAssurance.value = false;
      const customToastMessage = i18n.t("message.toast.paid.title");
      const response = await authenticatedFetch(
        `${API_URL}members/assurance/payment`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        customToastMessage,
        true,
      );
      if (response) {
        isRequestMemberAssurance.value = false;
        return response;
      }
      isRequestMemberAssurance.value = false;
    } catch (err: any) {
      isRequestMemberAssurance.value = false;
      errorMemberAssurance.value = true;
    }
  };

  return {
    regulationMemberAssurance,
    fetchMembersAssurances,
    isRequestMemberAssurance,
    errorMemberAssurance,
  };
}
